module.exports = __webpack_public_path__ + "img/r3.87378c00.svg";